<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{ $t('VenteLot') }}</h1>
          <h2 class="page-subtitle">{{ $t('Total') }} : {{ totalCount }}
          <b-icon id="info-circle-bilan" class="ml-2" icon="info-circle" variant="secondary"></b-icon>
          <b-tooltip html target="info-circle-bilan" variant="dark">
            Lots des opérations EXE uniquement.
          </b-tooltip>
          </h2>
        </div>
        <b-button v-if="allowCreate" variant="primary" @click="clickOnCreateBtn">
          <plus-icon class="mr-1" size="18"/>
          {{ $t('Add') }} {{ $t('venteLot.add') }}
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableVenteLot"
          :deleteItem=allowDelete
          :editItem=allowEdit
          :empty-button="$t('venteLot.emptyButton').toString()"
          :empty-text="$t('venteLot.emptyText').toString()"
          :empty-title="$t('venteLot.emptyTitle').toString()"
          :fields="tableFields"
          get-b122-table-results-url="/venteLot/getB122TableResults"
          identifier="B122TableVenteLot"
          init-b122-table-url="/venteLot/initB122Table"
          @add="clickOnCreateBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnShowBtn="clickOnShowBtn"
          @setTotalCount="setTotalCount">

          <template #cell(agent)="data">
            <template v-if="data.item.agent.firstname">
              {{ data.item.agent.firstname + ' ' + data.item.agent.lastname }}
            </template>
          </template>

          <template #cell(name)="data">
            <template v-if="data.item.name">
              <div class="d-flex">
                <span>{{ data.item.name }}</span>
                <span
                  :class="{'bilan-exe':data.item.operationLot.bilanType ==='EXE','bilan-avp':data.item.operationLot.bilanType ==='AVP'}"
                  class="bilanType-vignette">{{ data.item.operationLot.bilanType }}</span>
              </div>
            </template>
          </template>

          <template #cell(statut)="data">
            <div v-if="data.item.statut === 'DISPONIBLE'">
                <span class="dispo p-2">
                  {{ $t('vente.lot.statut.enum.disponible') }}
                </span>
            </div>
            <div v-if="data.item.statut === 'PRE_RESERVE'">
                <span class="prereserver p-2">
                  {{ $t('vente.lot.statut.enum.prereserve') }}
                </span>
            </div>
            <div v-if="data.item.statut === 'VENDU'">
                <span class="vendu p-2">
                  {{ $t('vente.lot.statut.enum.vendu') }}
                </span>
            </div>
            <div v-if="data.item.statut === 'A_VALIDER'">
                <span class="valider p-2">
                  {{ $t('vente.lot.statut.enum.valider') }}
                </span>
            </div>
          </template>

        </b122-table>
      </b-card>
    </b-container>

    <Item-delete-modal
      :is-feminine="true"
      :selectedItem="ui.venteLotSelected"
      controllerName="venteLot"
      itemSingularName="vente"
      itemSingularNameUpp="Vente"
      @didDeleteItem="didDeleteVenteLot()">
    </Item-delete-modal>

  </div>
</template>

<script>

import B122Table from '../../components/b122/B122Table'
import ItemDeleteModal from '../../components/b122/ItemDeleteModal'

export default {

  name: 'VenteLotIndex',

  components: {
    B122Table,
    ItemDeleteModal
  },

  data() {
    return {
      username: this.$store.getters.username,
      isEstateAgent: this.$store.getters.isEstateAgent,
      isCollaborator: this.$store.getters.isCollaborator,
      totalCount: 0,
      allowCreate: true,
      allowDelete: true,
      allowEdit: true,
      urbanStudyId: this.$route.params.urbanStudyId,

      ui: {
        venteLotSelected: null
      }

    }
  },

  computed: {

    tableFields() {
      return [
        {
          label: this.$i18n.t('Show'),
          key: 'show',
          sortable: false
        },
        {
          label: this.$i18n.t('venteLot.LotCoPro'),
          key: 'lotCoPro',
          sortable: true
        },
        {
          label: this.$i18n.t('venteLot.Name'),
          key: 'name',
          sortable: false
        },
        {
          label: this.$i18n.t('venteLot.Operation'),
          key: 'operation.name',
          sortable: false
        },
        {
          label: this.$i18n.t('venteLot.Type'),
          key: 'type',
          sortable: true
        },
        {
          label: this.$i18n.t('venteLot.PrixVente'),
          key: 'prix',
          sortable: true,
          formatter: function (value) {
            return Intl.NumberFormat().format(value.toFixed(2)) + " €"
          }
        },
        {
          label: this.$i18n.t('venteLot.CreationDate'),
          key: 'creationDate',
          sortable: true,
          formatter: function (value) {
            return new Date(value).toLocaleString('fr-FR')
          }
        },
        {
          label: this.$i18n.t('venteLot.Statut'),
          key: 'statut',
          sortable: false
        },
        {
          label: this.$i18n.t('venteLot.Agent'),
          key: 'agent',
          sortable: false
        },
        {
          label: '',
          key: 'actions'
        }
      ]
    }

  },

  methods: {

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'VenteLotCreateEdit'
      })
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'VenteLotShow',
        params: {
          venteLotId: row.item.id
        }
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'VenteLotCreateEdit',
        params: {
          venteLotId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.venteLotSelected = row.item
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteVenteLot() {
      this.ui.venteLotSelected = null
      this.$refs.B122TableVenteLot.refreshTable()
    },

  }
}
</script>

<style scoped>

.dispo {
  border-radius: 30px;
  text-align: center;
  background: #06C9B3;
  color: white;
}

.prereserver {
  border-radius: 30px;
  text-align: center;
  background: #009DFF;
  color: white;
}

.valider {
  border-radius: 30px;
  text-align: center;
  background: #9E0430;
  color: white;
}

.vendu {
  border-radius: 30px;
  text-align: center;
  background: #FF9D00;
  color: white;
}

.bilanType-vignette {
  color: var(--main-white);
  text-align: center;
  font: normal normal normal 10px/13px Montserrat-Bold, "Arial", sans-serif;
  letter-spacing: 1px;
  width: 40px;
  height: 20px;
  border-radius: 4px;
  opacity: 1;
  padding: 0.5em;
  margin-left: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
}

</style>



// WEBPACK FOOTER //
// src/views/venteLot/VenteLotIndex.vue